import {
  CollectRestoreTransaction_CollectFile_Request,
  CollectRestoreTransaction_CollectForm_Request,
  CollectRestoreTransaction_CollectItem_Request,
  CollectRestoreTransaction_Count_Request,
  CollectRestoreTransaction_Count_Response,
  CollectRestoreTransaction_FreePhoto_Request,
  CollectRestoreTransaction_FreePhoto_Response,
  CollectSyncTransaction_Create_Request,
  CollectSyncTransaction_Create_Response,
  CollectSyncTransaction_UploadCollectFile_Request,
  CollectSyncTransaction_UploadCollectFile_Response,
  CollectSyncTransaction_UploadFreePhoto_Request,
  CollectSyncTransaction_UploadFreePhoto_Response,
  CollectSyncTransaction_UploadFreePhotoFile_Response,
} from '../models/CollectSyncTransaction';
import { getAxiosInstance } from '../../react/utils/networkUtil';
import { CollectSyncTransaction_GetOne_Response } from '../models/CollectSyncTransaction';
import {
  CollectSyncTransaction_UploadCollectForm_Request,
  CollectSyncTransaction_UploadCollectForm_Response,
} from '../models/CollectSyncTransaction';
import {
  CollectSyncTransaction_UploadCollectItem_Request,
  CollectSyncTransaction_UploadCollectItem_Response,
} from '../models/CollectSyncTransaction';
import { CollectSyncTransaction_Run_Response } from '../models/CollectSyncTransaction';
import {
  CollectRestoreTransaction_CollectForm_Response,
  CollectRestoreTransaction_CollectItem_Response,
  CollectRestoreTransaction_CollectFile_Response,
  CollectRestoreTransaction_DownloadFile_Response,
  CollectRestoreTransaction_DownloadFreePhotoFile_Response,
} from '../models/CollectSyncTransaction';

export const remote_CollectSyncTransaction_create = async (
  request: CollectSyncTransaction_Create_Request,
): Promise<CollectSyncTransaction_Create_Response> => {
  const response = await getAxiosInstance().post('/api/geocollect/sync-transaction/create', request);
  return response.data;
};

/**
 * Get collect sync transaction by numeric ID
 * @deprecated Use remote_CollectSyncTransaction_getOneByDocumentId instead for better performance with documentId
 */
export const remote_CollectSyncTransaction_getOne = async (id: string): Promise<CollectSyncTransaction_GetOne_Response> => {
  const response = await getAxiosInstance().get(`/api/geocollect/sync-transaction/get-one/${id}`);
  return response.data;
};

export const remote_CollectSyncTransaction_getOneByDocumentId = async (documentId: string): Promise<CollectSyncTransaction_GetOne_Response> => {
  const response = await getAxiosInstance().get(`/api/geocollect/sync-transaction/document-id/${documentId}`);
  return response.data;
};

export const remote_CollectSyncTransaction_uploadCollectForm = async (
  id: number,
  request: CollectSyncTransaction_UploadCollectForm_Request,
): Promise<CollectSyncTransaction_UploadCollectForm_Response> => {
  const response = await getAxiosInstance().post(`/api/geocollect/sync-transaction/upload-collect-form/${id}`, request);
  return response.data;
};

export const remote_CollectSyncTransaction_uploadCollectItem = async (
  id: number,
  request: CollectSyncTransaction_UploadCollectItem_Request,
): Promise<CollectSyncTransaction_UploadCollectItem_Response> => {
  const response = await getAxiosInstance().post(`/api/geocollect/sync-transaction/upload-collect-item/${id}`, request);
  return response.data;
};

export const remote_CollectSyncTransaction_uploadCollectFile = async (
  id: number,
  request: CollectSyncTransaction_UploadCollectFile_Request,
): Promise<CollectSyncTransaction_UploadCollectFile_Response> => {
  const formData = new FormData();

  for (let i = 0; i < request.files.length; i++) {
    const item = request.files[i];
    formData.append(item.name, item);
  }

  const response = await getAxiosInstance().post(`/api/geocollect/sync-transaction/upload-collect-file/${id}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const remote_CollectSyncTransaction_uploadCollectFile_RN = async (
  id: number,
  request: FormData,
): Promise<CollectSyncTransaction_UploadCollectFile_Response> => {
  const response = await getAxiosInstance().post(`/api/geocollect/sync-transaction/upload-collect-file/${id}`, request, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const remote_CollectSyncTransaction_run = async (id: string): Promise<CollectSyncTransaction_Run_Response> => {
  const response = await getAxiosInstance().post(`/api/geocollect/sync-transaction/run/${id}`);
  console.log('data', response.data);
  return response.data;
};

export const remote_CollectRestoreTransaction_count = async (
  request: CollectRestoreTransaction_Count_Request,
): Promise<CollectRestoreTransaction_Count_Response> => {
  const response = await getAxiosInstance().get('/api/geocollect/restore/count', { params: request });
  return response.data;
};

export const remote_CollectRestoreTransaction_collectForm = async (
  request: CollectRestoreTransaction_CollectForm_Request,
): Promise<CollectRestoreTransaction_CollectForm_Response> => {
  const response = await getAxiosInstance().get('/api/geocollect/restore/collect-form', { params: request });
  return response.data;
};

export const remote_CollectRestoreTransaction_collectItem = async (
  request: CollectRestoreTransaction_CollectItem_Request,
): Promise<CollectRestoreTransaction_CollectItem_Response> => {
  const response = await getAxiosInstance().get('/api/geocollect/restore/collect-item', { params: request });
  return response.data;
};

export const remote_CollectRestoreTransaction_collectFile = async (
  request: CollectRestoreTransaction_CollectFile_Request,
): Promise<CollectRestoreTransaction_CollectFile_Response> => {
  const response = await getAxiosInstance().get('/api/geocollect/restore/collect-file', { params: request });
  return response.data;
};

export const remote_CollectRestoreTransaction_downloadFile = async (
  uuid: string,
): Promise<CollectRestoreTransaction_DownloadFile_Response> => {
  const response = await getAxiosInstance().get(`/api/geocollect/restore/download-file/${uuid}`, {
    responseType: 'blob',
  });
  return response.data;
};

// Free Photo APIs

export const remote_CollectSyncTransaction_uploadFreePhoto = async (
  id: number,
  request: CollectSyncTransaction_UploadFreePhoto_Request,
): Promise<CollectSyncTransaction_UploadFreePhoto_Response> => {
  const response = await getAxiosInstance().post(`/api/geocollect/sync-transaction/upload-free-photo/${id}`, request);
  return response.data;
};

export const remote_CollectSyncTransaction_uploadFreePhotoFile_RN = async (
  id: number,
  request: FormData,
): Promise<CollectSyncTransaction_UploadFreePhotoFile_Response> => {
  const response = await getAxiosInstance().post(`/api/geocollect/sync-transaction/upload-free-photo-file/${id}`, request, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const remote_CollectRestoreTransaction_freePhoto = async (
  request: CollectRestoreTransaction_FreePhoto_Request,
): Promise<CollectRestoreTransaction_FreePhoto_Response> => {
  const response = await getAxiosInstance().get('/api/geocollect/restore/free-photo', { params: request });
  return response.data;
};

export const remote_CollectRestoreTransaction_downloadFreePhotoFile = async (
  uuid: string,
): Promise<CollectRestoreTransaction_DownloadFreePhotoFile_Response> => {
  const response = await getAxiosInstance().get(`/api/geocollect/restore/download-free-photo-file/${uuid}`, {
    responseType: 'blob',
  });
  return response.data;
};
